import Vue from 'vue'

export default ({ appCache, module }) => {
  return new Vue({
    data () {
      return {
        all: appCache.modules
      }
    },
    computed: {
      current () {
        return this.all[module]
      }
    },
    methods: {
      getPlans (module) {
        return Object.values(this.all[module].plan.list)
      },
      getOptions (module) {
        return Object.values(this.all[module].plan.options)
      },
      getPlan(module, plan) {
        return this.all[module].plan.list[plan]
      }
    }
  })
}